import { useState, useEffect, SetStateAction } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Table } from "react-bootstrap";

import { prependListener } from "process";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate, useParams } from "react-router";
import { IProductsList } from "../../dto/IProducts";
import Select, { SingleValue } from "react-select";
import { IExport } from "../../../exports/dto/IExports";
import { ExportService } from "../../../exports/service";
import { ErrorToast, SuccessToast } from "../../../../shared/toasters/toasters";
import ImageContainer from "../../../../shared/gallery/ImageContainer";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../../store/rootReducer";
import { ProductsService } from "../../service";
import ProductMediaPictures from "../../components/ProductsMediaPictures";
import { EmptyState } from "../../../../shared/components/EmptyState";

interface Props {
  isWorkflowUpdate?: boolean;
  selectedProductId?: number;
  setSelectedProductId?: React.Dispatch<SetStateAction<number>> | undefined;
}
type FileType = {
  name: string;
  nameOriginal: string;
  mime: string;
  size: number;
};

type Picture = {
  id: number;
  createdAt: string;
  updatedAt: string;
  position: number | null;
  file: FileType;
  path: string;
};
export const ProductsMediaUpdate = ({
  isWorkflowUpdate = false,
  selectedProductId,
}: Props) => {
  const { id, productId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state: pagination, state: close }: any = useLocation();
  const [pictures, setPictures] = useState<Picture[]>([]);
  const [triggerUpdatePictures, setTriggerUpdatePictures] =
    useState<boolean>(false);
  const location = useLocation();
  const [currentProduct, setCurrentProduct] = useState<IProductsList>();
  const [exportData, setExportData] = useState<{
    clientExport: null | number;
  }>({ clientExport: null });
  const secondViewPagination = useSelector(
    (state: IAllStates) => state.secondViewPagination as any
  );
  const tab = "BASE_DATA";
  const [exportsList, setExportsList] = useState<IExport[]>([]);

  const navBaseData = () => {
    if (close?.close === "export") {
      navigate(`/app/products/base-data/${id}`, {
        state: {
          close: "export",
          idExport: (location.state as any).idExport,
          headerName: (location.state as any).headerName,
        },
      });
    } else {
      navigate(`/app/products/base-data/${id}`, { state: pagination });
    }
  };

  const navAttributes = () => {
    if (close?.close === "export") {
      navigate(`/app/products/attributes/${id}`, {
        state: {
          close: "export",
          idExport: (location.state as any).idExport,
          headerName: (location.state as any).headerName,
        },
      });
    } else {
      navigate(`/app/products/attributes/${id}`, { state: pagination });
    }
  };
  const navContent = () => {
    if (close?.close === "export") {
      navigate(`/app/products/edit-content/${id}`, {
        state: {
          close: "export",
          idExport: (location.state as any).idExport,
          headerName: (location.state as any).headerName,
        },
      });
    } else {
      navigate(`/app/products/edit-content/${id}`, { state: pagination });
    }
  };
  const selectExportHandler = (e: any) => {
    setExportData({ clientExport: +e.value });
  };
  const exportClickHandler = () => {
    ExportService.exportProduct(exportData, +id!)
      .then((res) => {
        SuccessToast(`${t("toasts.successfully_exported")}`);
      })
      .catch((err) => console.log(err));
  };
  const checkHref = () => {
    if (
      currentProduct?.sourceUrl === null ||
      currentProduct?.sourceUrl === "" ||
      currentProduct?.sourceUrl === undefined
    ) {
      return "/403";
    } else if (
      currentProduct?.sourceUrl?.includes("https://") ||
      currentProduct?.sourceUrl?.includes("http://")
    ) {
      return currentProduct?.sourceUrl;
    } else {
      return `https://${currentProduct?.sourceUrl}`;
    }
  };
  const goBack = () => {
    if (
      location?.pathname?.includes("/app/pending-products/imported/base-data/")
    ) {
      navigate(-1);
    } else {
      navigate(-1);
    }
  };
  const handleClose = () => {
    if (isWorkflowUpdate) {
      navigate(`/app/workflow/step3/${id}`);
    } else {
      navigate("/app/products/base-data", {
        state:
          (location.state as any)?.pagination ??
          secondViewPagination?.pagination,
      });
    }
  };
  const backHandle = () => {
    if (close?.close === "export") {
      navigate(`/app/export/list/${close?.idExport}`, {
        state: (location.state as any)?.headerName,
      });
      // goBack()
    } else if (close?.close === "attributes") {
      navigate(`/admin/attributes/list/${close?.idExport}`, {
        state: (location.state as any)?.headerName,
      });
      // }
      // else if (handleClose) {
      //   handleClose();
      // KAD NAPRAVIMO WORKFLOW STEP OVO TREBA ====================================================================================================================
    } else {
      goBack();
    }
  };
  const getProductId = () => {
    id &&
      tab &&
      ProductsService.getProductById(
        isWorkflowUpdate ? Number(selectedProductId) : +id,
        tab
      )
        .then((response) => {
          setCurrentProduct(response);
          setPictures(response?.productPictures);
        })
        .catch((error) => {
          ErrorToast(error);
          //novo
          navigate(-1);
        });
  };
  useEffect(() => {
    getProductId();
  }, [id, selectedProductId, isWorkflowUpdate, triggerUpdatePictures]);

  return (
    <>
      <Helmet>
        <title>
          {currentProduct?.title ?? "-"} {t("side_bar.media")}
        </title>
      </Helmet>
      <div className="">
        <div className="card">
          <div className="card-body">
            {!isWorkflowUpdate && (
              <div className="d-sm-flex align-items-center justify-content-between mb-3">
                <ul className="nav nav-pills nav-fill">
                  <li onClick={() => navBaseData()}>
                    <span className="nav-link cursor-pointer text-dark">
                      {t("products.base_data_update")}
                    </span>
                  </li>
                  <li onClick={() => navAttributes()}>
                    <span className="nav-link cursor-pointer text-dark">
                      {t("products.attributes_update")}
                    </span>
                  </li>
                  <li onClick={() => navContent()}>
                    <span className="nav-link cursor-pointer text-dark">
                      {t("products.content_update")}
                    </span>
                  </li>
                  <li className="nav-item">
                    <span className="nav-link active">
                      {t("products.media_update")}
                    </span>
                  </li>
                </ul>
                <div
                  className="row  align-items-end"
                  style={{ width: 500, position: "relative", zIndex: "1000" }}
                >
                  <div className="col-9">
                    <h6 className="m-0 p-0 mb-2">{t("global.export")}:</h6>
                    <Select
                      className="react-select-field"
                      onChange={selectExportHandler}
                      options={exportsList.map((exportItem) => ({
                        label: exportItem.name,
                        value: exportItem.id,
                      }))}
                    />
                  </div>
                  <button
                    className="btn btn-primary word-wrap col-3"
                    onClick={exportClickHandler}
                  >
                    {t("global.add_to_export")}
                  </button>
                </div>
              </div>
            )}

            <div className="d-flex align-items-center justify-content-between">
              <button
                onClick={() => backHandle()}
                className="btn btn-info d-flex align-items-center mb-3"
              >
                <i className="ri-arrow-left-line me-1"></i>
                {t("products.back")}
              </button>
              <div className="d-flex">
                <button
                  onClick={() => navigate(`/app/products/data-history/${id}`)}
                  className="btn btn-secondary d-flex align-items-start justify-content-start mb-3 me-3"
                >
                  <i className="ri-history-line me-1"></i>
                  {t("products.data_history")}
                </button>
                <a rel="noreferrer" target="_blank" href={checkHref()}>
                  <button className="btn btn-primary">
                    {t("products.source_url")}
                  </button>
                </a>
              </div>
            </div>
            <div className="d-flex align-items-center mb-3">
              <div className="d-flex gap-3 align-items-center">
                <ImageContainer img={currentProduct?.productPictures ?? []} />
                <div>
                  <h2>{currentProduct?.title}</h2>
                  <p>{currentProduct?.eanCode}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {pictures?.length > 0 ? (
        <ProductMediaPictures
          pictures={pictures}
          setPictures={setPictures}
          isWorkflowUpdate={isWorkflowUpdate}
          setTriggerUpdatePictures={setTriggerUpdatePictures}
        />
      ) : (
        <EmptyState />
      )}
    </>
  );
};
